import * as Sentry from '@sentry/react';
export type Extra = unknown;
export type Extras = Record<string, Extra>;

export function sendToSentry(
    errorName: string,
    errorMessage: string,
    extras: Extras
) {
    const newError = new Error();
    newError.name = errorName;
    newError.message = errorMessage;

    Sentry.setExtras(extras);

    Sentry.captureException(newError);
}
